import { useEffect, useState } from 'react';
import { Button } from '@kizen/kds/Button';
import { TextEditorToolbarSection } from '../../styles';
import { useGridLikeFlexChildProps } from 'components/StandaloneToolBar/components/GridLikeFlex';
import { useMarkdownEditor } from 'components/WYSIWYG/MarkdownEditor/context';

export const HistoryToolbarSection = () => {
  const { editor, subscribeToUpdate } = useMarkdownEditor();
  const [ref, props] = useGridLikeFlexChildProps();
  const [{ enabledUndo, enabledRedo }, setEnabled] = useState(() => ({
    enabledUndo: editor?.can().undo(),
    enabledRedo: editor?.can().redo(),
  }));

  useEffect(() => {
    return subscribeToUpdate('history-toolbar-section', ({ editor }) => {
      if (!editor) {
        return;
      }
      setEnabled({
        enabledUndo: editor.can().undo(),
        enabledRedo: editor.can().redo(),
      });
    });
  }, [subscribeToUpdate]);

  if (!editor) {
    return null;
  }

  return (
    <TextEditorToolbarSection ref={ref} gap={15} {...props}>
      <div
        style={{
          color: enabledUndo
            ? 'var(--color-font-primary)'
            : 'var(--color-background-medium)',
        }}
      >
        <Button
          variant="text"
          color="inherit"
          rightIcon="text-undo"
          disabled={!enabledUndo}
          onClick={() => {
            enabledUndo && editor.chain().focus().undo().run();
          }}
        />
      </div>
      <div
        style={{
          color: enabledRedo
            ? 'var(--color-font-primary)'
            : 'var(--color-background-medium)',
        }}
      >
        <Button
          variant="text"
          color="inherit"
          rightIcon="text-redo"
          disabled={!enabledRedo}
          onClick={() => {
            enabledRedo && editor.chain().focus().redo().run();
          }}
        />
      </div>
    </TextEditorToolbarSection>
  );
};
